import axios from 'axios/index'
import api from './api/login.api'

export default {
    /**
     * 登录
     */
    login(params) {
        return axios.post(api.login, params)
    },

    /**
     * 登出
     */
    loginOut(data) {
        return axios.get(api.loginOut, data);
    },

    /**
     * 获取令牌信息
     */
    findUserToken(params) {
        return axios.post(api.findUserToken, params)
    },
}